export default {
	title: '终端通道',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	noData: {
		title: '暂无终端通道数据',
		description: '当前没有找到相关的终端通道数据'
	},
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		projNo: '所属项目',
		orgId: '机构名称',
		terminalId: '终端 Id',
		terminalNumber: '终端编号',
		channel: '通道号',
		hasSensor: '是否有传感器',
		deviceId: '设备',
		sensorName: '传感器名称',
		dataType: '数据类型',
		dataStatus: '数据是否正常',
		placeholder: {
			projNo: '请选择所属项目',
			orgId: '请选择机构名称',
			terminalId: '请输入终端 Id',
			terminalNumber: '请输入终端编号',
			channel: '请输入通道号',
			hasSensor: '请选择是否有传感器',
			deviceId: '请选择设备',
			sensorName: '请输入传感器名称',
			dataType: '请选择数据类型',
			dataStatus: '请选择数据是否正常'
		}
	},
	table: {
		projNo: '项目编号',
		orgId: '机构',
		terminalId: '终端 Id',
		terminalNumber: '终端编号',
		channel: '通道号',
		hasSensor: '是否有传感器',
		deivceName: '设备名称',
		sensorName: '传感器名称',
		dataType: '数据类型',
		dataStatus: '数据是否正常'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	options: {
		hasSensor: {
			yes: '是',
			no: '否'
		},
		dataType: {
			vibration: '单振动',
			tempVibration: '温振',
			tempVibrationSound: '温振声',
			current: '电流',
			speed: '转速'
		},
		dataStatus: {
			normal: '正常',
			abnormal: '异常',
			noData: '没有数据'
		}
	}
}
